import Api from '../common/Api';
import { Backend, headers } from "../common/Config";
import Helpers from '../common/Helpers';

export default class DashboardServices {

    static async counters() {
        const response = await Api.get({
            url: `${Backend}/counters`,
            headers: headers
        });
        return Helpers.dataReturn(response);
    };

    static async driversAvailables(date) {
        let url = `${Backend}/drivers/available`;
        if (date) {
            url += `?date=${encodeURIComponent(date)}`;
        }
        const response = await Api.get({
            url,
            headers: headers
        })
        return Helpers.dataReturn(response)
    }

    static async totalSalesByClient(startDate, endDate) {
        let url = `${Backend}/dashboard/client-services`;
        const params = [];
        if (startDate) params.push(`start_date=${encodeURIComponent(startDate)}`);
        if (endDate) params.push(`end_date=${encodeURIComponent(endDate)}`);
        if (params.length) url += `?${params.join('&')}`;

        const response = await Api.get({
            url,
            headers: headers
        })

        return Helpers.dataReturn(response)
    }

    static async vehiclesAvailable(date) {
        let url = `${Backend}/dashboard/vehicles/available`;
        if (date) {
            url += `?date=${encodeURIComponent(date)}`;
        }
        const response = await Api.get({
            url,
            headers: headers
        })
        return Helpers.dataReturn(response)
    }

    static async salesByTypeVehicle(startDate, endDate) {
        let url = `${Backend}/dashboard/sales-by-type-vehicle`;
        const params = [];
        if (startDate) params.push(`start_date=${encodeURIComponent(startDate)}`);
        if (endDate) params.push(`end_date=${encodeURIComponent(endDate)}`);
        if (params.length) url += `?${params.join('&')}`;
        const response = await Api.get({
            url,
            headers: headers
        })
        return Helpers.dataReturn(response)
    }

    static async totalSalesByCity(startDate, endDate) {
        let url = `${Backend}/dashboard/sales-by-city`;
        const params = [];
        if (startDate) params.push(`start_date=${encodeURIComponent(startDate)}`);
        if (endDate) params.push(`end_date=${encodeURIComponent(endDate)}`);
        if (params.length) url += `?${params.join('&')}`;

        const response = await Api.get({
            url,
            headers: headers
        });
        return Helpers.dataReturn(response);
    }

    static async salesByVehicle(startDate, endDate) {
        let url = `${Backend}/dashboard/sales-by-vehicle`;
        const params = [];
        if (startDate) params.push(`start_date=${encodeURIComponent(startDate)}`);
        if (endDate) params.push(`end_date=${encodeURIComponent(endDate)}`);
        if (params.length) url += `?${params.join('&')}`;

        const response = await Api.get({
            url,
            headers: headers
        });
        return Helpers.dataReturn(response);
    }

    static async sendEmail() {
        const response = await Api.get({
            url: `${Backend}/dashboard/send-email`,
            headers: headers
        });
        return Helpers.dataReturn(response);
    }

    static async downloadReport(startDate, endDate) {
        const url = `${Backend}/informes/services/compress?start_date=${encodeURIComponent(startDate)}&end_date=${encodeURIComponent(endDate)}`;
        const response = await Api.get({
            url,
            headers: headers
        });
        return Helpers.dataReturn(response);
    }

}